import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer bg-dark-custom text-white py-4">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-3 col-sm-12 mb-4">
            <h5>Seal Active</h5>
            <p>
              Location: 10, Balaji Layout,<br />
              Mallathahalli, Banglore, 560056.
            </p>
          </div>

          <div className="col-md-3 col-sm-12 mb-4">
            <h5>Our Products</h5>
            <ul className="list-unstyled">
              <li className="mb-2">Hot Melt Adhesive</li>
              <li className="mb-2">Water Based Adhesive</li>
            </ul>
          </div>

          <div className="col-md-3 col-sm-12 mb-4">
            <h5>Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2">Home</li>
              <li className="mb-2">Products</li>
              <li className="mb-2">About Us</li>
              <li className="mb-2">Contact Us</li>
            </ul>
          </div>

          <div className="col-md-3 col-sm-12 mb-4">
            <h5>Contact Info</h5>
            <p>
              Mail Us: sales@sealactive.in<br />
              Contact: +91 9611589138 , 9964192505
            </p>
            <div>
              <a href="https://twitter.com" className="text-white me-3">
                <i className="bi bi-twitter"></i>
              </a>
              <a href="https://facebook.com" className="text-white me-3">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="https://instagram.com" className="text-white me-3">
                <i className="bi bi-instagram"></i>
              </a>
              <a href="https://linkedin.com" className="text-white">
                <i className="bi bi-linkedin"></i>
              </a>
            </div>
          </div>
        </div>

        <hr className="my-4 bg-light" />

        <div>
          <p className="mb-0" style={{textAlign:'center'}}>
            Copyright © 2025 All Rights Reserved by Seal Active Private Limited
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
